import { render, staticRenderFns } from "./ServiceOrderManagement.vue?vue&type=template&id=44a50442&scoped=true"
import script from "./ServiceOrderManagement.vue?vue&type=script&lang=js"
export * from "./ServiceOrderManagement.vue?vue&type=script&lang=js"
import style0 from "./ServiceOrderManagement.vue?vue&type=style&index=0&id=44a50442&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a50442",
  null
  
)

export default component.exports